export default "__VITE_PUBLIC_ASSET__659f5fa3__"